import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  capitalize: {
    textTransform: 'capitalize',
  },
}))

export default props => {
  const classes = useStyles()
  const {
    data,
    keyTitle,
    keyValue,
  } = props

  return (
    <List className={classes.root}>
      {data.map((obj, i) => (
        <React.Fragment key={i.toString()}>
          <ListItem alignItems='flex-start'>
            <ListItemText
              primary={(
                <b className={classes.capitalize}>
                  {obj[keyTitle] || ''}
                </b>
              )}
              secondary={(
                <span className={classes.capitalize}>
                  {obj[keyValue] || ''}
                </span>
              )}
            />
          </ListItem>
          <Divider component='li' />
        </React.Fragment>
      ))}
    </List>
  )
}
